import {
  TEntityResponse,
  TEntityListResponse,
  TAccessTokenResBody,
  TAccessTokenSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TAccessTokensClient = {
  revoke(id: string): Promise<void>;
  get(id: string): Promise<TEntityResponse<'access-token', TAccessTokenResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'access-token', TAccessTokenSummaryResBody> | undefined>;
};

function AccessTokensClient(apiClient: TAPIClient): TAccessTokensClient {
  return {
    async revoke(id: string): Promise<void> {
      return await apiClient.delete(`/access-tokens/${id}`);
    },

    async get(id: string): Promise<TEntityResponse<'access-token', TAccessTokenResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'access-token', TAccessTokenResBody>>(`/access-tokens/${id}`);

      if (data && data.type !== 'access-token') {
        throw new Error('Invalid entity type received, expected: access-token, received: ' + data.type);
      }

      return data;
    },

    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'access-token', TAccessTokenSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'access-token', TAccessTokenSummaryResBody>>(
        `/access-tokens?sort[created_at]=desc&limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'access-token') {
        throw new Error('Invalid entity type received, expected: access-token, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TAccessTokensClient, AccessTokensClient };
